import { motion } from "framer-motion";

const steps = ["Site Preparation", "Concrete", "Construction", "Finishes", "Completion"];

export default function OneTeam() {
  return (
    <section id="one-team" className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10" data-testid="one-team-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F5F5F5]"
          data-testid="one-team-headline"
        >
          One Team.{" "}
          <span className="italic text-[#D4AF37]">From Site Preparation to Completion.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-8 max-w-2xl mx-auto text-base font-light leading-relaxed tracking-wide text-[#A3A3A3]"
          data-testid="one-team-copy"
        >
          Veritas coordinates excavation, concrete, construction, renovations,
          exterior improvements, and development services through one
          professional team — reducing the need to manage multiple contractors.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mt-14 flex flex-wrap items-center justify-center gap-y-4"
          data-testid="one-team-flow"
        >
          {steps.map((s, i) => (
            <span key={s} className="flex items-center">
              <span className="border border-[#D4AF37]/30 text-[#F5F5F5] px-5 sm:px-7 py-3 text-[10px] sm:text-[11px] tracking-[0.28em] uppercase whitespace-nowrap" data-testid={`one-team-step-${i}`}>
                {s}
              </span>
              {i < steps.length - 1 && (
                <span className="w-6 sm:w-10 h-px bg-[#D4AF37]/50 mx-1" aria-hidden="true" />
              )}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
